import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { InputComponent, MakeProvider } from '../input-component';
import { IAddressObject, MapUtilities } from 'src/app/core/helper/map-utils';
import { InputOptions } from '../../data-table/data-table';
import { Log } from 'src/app/core/log';

@Component({
  selector: 'app-google-address-input',
  templateUrl: './google-address-input.component.html',
  styleUrls: ['./google-address-input.component.scss', '../form-inputs-style.scss'],
  providers: [MakeProvider(GoogleAddressInputComponent)]
})
export class GoogleAddressInputComponent extends InputComponent implements OnInit {

  @Input() type?: InputOptions = InputOptions.TEXT;
  @Output() keyup: EventEmitter<void> = new EventEmitter<void>();

  constructor() { super(); }

  ngOnInit() {
    setTimeout(() => {
      const addressInput = document.getElementById(this.id) as HTMLInputElement;
      // find the text input element and initialize the google maps autocomplete
      if (addressInput != null) {
        MapUtilities.initMapsAutoComplete(
          this.id,
          true,
          (addr, place) => this.addressSelected(addr, place)
        );
      } else {
        console.error('Could not find address input element with id: ' + this.id);
      }
    }, 500);
  }

  override checkValidity() {
    super.checkValidity();
    // if (this.isValid) {
    //   this.checkingValidity.emit(this);
    // }
  }

  keyUp(evt) {
    this.keyup.emit();
  }

  addressSelected(addr: string, place: IAddressObject) {
    Log.debug('Address Selected: ', addr);
    Log.debug('Place: ', place);


    // rebuild the address to be Number Street, City, Province, Postal Code
    const address = `${place.streetNumber} ${place.street}, ${place.city}, ${place.state} ${place.postalCode}, ${place.country}`;
    this.value = address;
  }
}
